<template>
  <div id="checkout-existing-account" class="checkout-existing-account">
    <img class="auth-container-logo" src="@/assets/playkids-logo-black.png" alt />
    <div class="checkout-existing-account__headline">
      <h1>Libere benefícios exclusivos</h1>
      <p>Você já tem uma conta PlayKids. Que tal agora ter acesso ilimitado e desenvolver ainda mais seu pequeno?</p>
    </div>
    <existing-account-arguments />
    <btn color="purple" @click="$emit('continue')">continuar</btn>
    <p>
      <a @click="logout" :class="signingOut ? 'loading' : ''">
        Clique aqui
        <spinner v-if="signingOut" size="24px" borderWidth="2px" :active="true" />
      </a>
      para fazer login com outro e-mail
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'checkout-existing-account',
  data: () => ({
    signingOut: false
  }),
  methods: {
    ...mapActions({
      signOut: 'authentication/signOut'
    }),
    async logout() {
      this.signingOut = true
      try {
        await this.signOut()
        this.$emit('signOut')
      } catch {}

      this.signingOut = false
    }
  }
}
</script>

<style lang="scss">
.checkout-existing-account {
  text-align: center;
  padding: 15px 25px;

  &__headline {
    & > h1 {
      margin: 0;
      color: #8D62FF;
      line-height: 1.35;
    }

    & > p {
      margin: 0;
      font-weight: normal;
      color: #6A6370;
      line-height: 1.35;
    }
  }

  & > .btn {
    width: 100%;
    max-width: 350px;
    margin: 12px auto 18px auto;
  }

  & > p {
    font-weight: normal;

    & > a {
      position: relative;
      display: inline-flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      transition: color 0.2s;

      &.loading {
        color: #8e899244;
      }

      & > .spinner {
        position: absolute;
      }
    }
  }

  @media screen and (min-width: 400px) {
    &__headline {
      width: min-content;
      margin: 0 auto;

      & > h1 {
        white-space: nowrap;
      }

      & > p {
        font-size: 16px;
      }
    }
  }

  @media screen and (min-width: 578px) {
    padding: 0;

    &__headline {
      & > h1 {
        font-size: 32px;
      }

      & > p {
        font-size: 16px;
      }
    }
  }

  @media only screen and (min-width: 1200px) {
    &__headline {
      & > h1 {
        font-size: 40px;
      }

      & > p {
        font-size: 16px;
      }
    }
  }
}
</style>
